import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcessFlowValve = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 24.5,
	viewBox: "0 0 50.0 24.5",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 4.5,
			width: 50,
			height: 20,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 5.0 1.5 L 40.0 1.5 M 3.0 4.5 L 3.0 24.5 M 0.0 14.5 L 3.0 14.5 M 3.0 4.5 L 50.0 24.5 M 50.0 4.5 L 3.0 24.5",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M 40.0 0.0 L 45.0 1.5 L 40.0 3.0 Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1
		})
	]
});
export default SvgExcessFlowValve;
